import { render } from "./WagerRewards.vue?vue&type=template&id=fdac5a5c&scoped=true"
import script from "./WagerRewards.vue?vue&type=script&lang=js"
export * from "./WagerRewards.vue?vue&type=script&lang=js"

import "./WagerRewards.vue?vue&type=style&index=0&id=fdac5a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdac5a5c"]])

export default __exports__